/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:53
 */
import Column from "./Column";

class TextColumn extends Column {

  constructor(params) {
    super(params);
    this.init();
  }

}

export default TextColumn;


// WEBPACK FOOTER //
// ./resources/assets/js/columns/TextColumn.js